import React, { useContext, useEffect, useState } from 'react'
import "./UserLog.css"
import { LanguageContext } from '../Language/LanguageContext'
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faKey } from '@fortawesome/free-solid-svg-icons'
import { listUserlog } from '../Network/Log'
import { listCompany } from '../Network/Company'
import { Loading, TablePagination } from '../Library'
import { NotifyContext } from '../Library/Notify'
import dayjs from 'dayjs'

function UserLog() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.activity_log
    const notify = useContext(NotifyContext)

    const [isLoading, setLoading] = useState(false)
    const [content, setContent] = useState([])
    const [companyList, setCompanyList] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [selectCompanyId, setSelectCompany] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 15
    const totalPage = Math.ceil(content.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const fetchData = (startDate, endDate, companyId, isExport) =>{
        setLoading(true)
        listUserlog(startDate, endDate, companyId, isExport,
        (content, count)=>{
            if(!isExport){
                setContent(content)
            }
            setLoading(false)
        },
        (error)=>{
            notify.showNotify("Something wrong", error.message, 2)
            setLoading(false)
        })
    }

    const fetchCompany = () =>{
        listCompany(
            (data)=>{ setCompanyList(data) },
            (error)=>{}
        )
    }

    const previewFilter = () =>{
        fetchData(startDate, endDate, selectCompanyId, false)
    }

    const clearFilter = () =>{
        fetchData(null, null, "", false)
        setStartDate(null)
        setEndDate(null)
        setSelectCompany("")
    }

    const exportExcel = () =>{
        fetchData(startDate, endDate, selectCompanyId, true)
    }

    useEffect(()=>{
        const fetchData = (startDate, endDate, companyId, isExport) =>{
            setLoading(true)
            listUserlog(startDate, endDate, companyId, isExport,
            (content, count)=>{
                if(!isExport){
                    setContent(content)
                }
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
        }
        fetchData(null, null, "", false)
        fetchCompany()
    },[])

    return (
        <div id="user-log">
            { isLoading ? <Loading/>: null }
            <div>{lang.user_log_desc}</div>
            <Row className="filter-section">
                <Col lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.start_datetime}</Form.Label>
                        <DatePicker
                        className="form-control"
                        showTimeSelect
                        placeholderText={lang.choose_datetime}
                        selected={startDate}
                        dateFormat="d MMMM yyyy H:mm"
                        onChange={(date)=>setStartDate(date)}
                        maxDate={new Date()}
                        />
                    </Form.Group>
                </Col>
                <Col lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.end_datetime}</Form.Label>
                        <DatePicker
                        className="form-control"
                        showTimeSelect
                        placeholderText={lang.choose_datetime}
                        selected={endDate}
                        dateFormat="d MMMM yyyy H:mm"
                        onChange={(date)=>setEndDate(date)}
                        minDate={startDate}
                        maxDate={new Date()}
                        />
                    </Form.Group>
                </Col>
                <Col lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.company}</Form.Label>
                        <Form.Control as="select" 
                        value={selectCompanyId}
                        onChange={(e)=>setSelectCompany(e.target.value)}>
                            <option value="">{lang.choose_company}</option>
                            { companyList.map((item, key) =>
                            <option value={item.id} key={key}>{item.name}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
            </Row>
            <div>
                <Button style={{ marginRight: 10 }} onClick={()=>previewFilter()}>
                    {lang.preview}
                </Button>
                <Button style={{ marginRight: 10 }} variant="secondary" onClick={()=>clearFilter()}>
                    {lang.clear}
                </Button>
                <Button variant="success" onClick={()=>exportExcel()}>
                    {lang.get_excel}
                </Button>
            </div>
            <div className="table-container">
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.first_name}</th>
                            <th>{lang.last_name}</th>
                            <th>{lang.email}</th>
                            <th>{lang.position}</th>
                            <th>{lang.date}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { content.slice(indexOfFirst, indexOfLast).map((item, key)=>
                            <UserlogRow
                            key={key}
                            firstName={item.firstName}
                            lastName={item.lastName}
                            email={item.email}
                            position={item.position}
                            loginDate={item.createdDate}
                            />
                        )}
                        { content.length === 0 ?
                        <tr style={{ textAlign: 'center' }}>
                            <td colSpan={6}>{lang.no_user_log}</td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
            </div>
            <div>
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
        </div>
    )
    
}

function UserlogRow({ firstName, lastName, email, position, loginDate }){
    return(
        <tr>
            <td>
                <FontAwesomeIcon icon={faKey}/>
            </td>
            <td>{firstName}</td>
            <td>{lastName}</td>
            <td>{email}</td>
            <td>{position}</td>
            <td>{dayjs(loginDate).format("D MMM YYYY - H:mm")}</td>
        </tr>
    )
}

export default UserLog
